import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getSpaceDetail,
  getSpaceDetailIsFetching,
} from "../../redux/selectors/spacesSelectors";
import { getSpaceDetailRequest } from "../../redux/actions/spacesActions";
import useVariants from "../../../../hooks/useVariants";
import { getProductModalVisibility } from "../../../ShopPage/redux/selectors/ProductModalSelectors";
import { productModalShow } from "../../../ShopPage/redux/actions/productModalActions";

const SpaceDetailContainer = ({ children, spaceId }) => {
  const dispatch = useDispatch();
  const space = useSelector((state) => getSpaceDetail(state, spaceId));
  const isFetching = useSelector(getSpaceDetailIsFetching);
  const variants = useVariants(spaceId);
  const isModalVisible = useSelector(getProductModalVisibility, shallowEqual);

  const handleOnDetailsClick = (productId, optionType, productType) => {
    dispatch(productModalShow(true, productId, optionType, productType));
  };

  const handleOnDismissModal = () => {
    dispatch(productModalShow(false));
  };

  useEffect(() => {
    dispatch(getSpaceDetailRequest(spaceId));
  }, []);

  return children({
    space,
    variants,
    isFetching: isFetching,
    handleOnDetailsClick,
    handleOnDismissModal,
    isModalVisible,
  });
};

export default SpaceDetailContainer;
